export const PARTNER_SLUG_PARAM = "partner"

export const PARTNER_COOKIE_NAME = "astra_partner_slug"

export const PARTNER_LS_KEY = "partner_slug"

export const PARTNER_LS_CAPTURED_AT_KEY = "partner_slug_captured_at"

export const PARTNER_AGENT_PARAM = "agente"

/** Links já distribuídos (IBH e outros). Leitura apenas; links novos usam `agente`. */
export const PARTNER_AGENT_LEGACY_PARAM = "corretor"

export const PARTNER_AGENT_COOKIE_NAME = "astra_partner_agent_code"

export const PARTNER_AGENT_LS_KEY = "partner_agent_code"

export const PARTNER_AGENT_LS_CAPTURED_AT_KEY = "partner_agent_code_captured_at"

export const PARTNER_ATTRIBUTION_WINDOW_DAYS_DEFAULT = 30

export type PartnerBenefitMode = "next_band" | "none" | "percent_increment"

/** Teto operacional do incremento (pontos percentuais) quando `percent_increment`. */
export const MAX_PARTNER_PERCENT_INCREMENT = 10

export function partnerBenefitAppliesDiscount(mode: string | null | undefined): boolean {
  return mode === "next_band" || mode === "percent_increment"
}

export function parseBenefitPercentIncrement(raw: unknown): number | null {
  const n = Number(raw)
  if (!Number.isFinite(n) || n <= 0 || n > MAX_PARTNER_PERCENT_INCREMENT) return null
  return Math.round(n * 100) / 100
}

export function formatPartnerPercentIncrementLabel(increment: number): string {
  return increment.toLocaleString("pt-BR", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  })
}

export function getPartnerAttributionWindowDays(): number {
  const raw = process.env.PARTNER_ATTRIBUTION_WINDOW_DAYS?.trim()
  if (raw) {
    const n = Number(raw)
    if (Number.isFinite(n) && n > 0 && n <= 365) return Math.floor(n)
  }
  return PARTNER_ATTRIBUTION_WINDOW_DAYS_DEFAULT
}
